import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import HelpIcon from '@material-ui/icons/Help';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { t } from 'src/lib/language';

const useStyles = makeStyles((theme) => ({
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(0.5),
    fontSize: '0.8rem',
  },
  triggerLabel: {
    fontSize: '0.7rem',
    textDecoration: 'underline',
  },
  content: {
    fontSize: '0.8rem',
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: 'rgb(13, 60, 97)',
    backgroundColor: 'rgb(232, 244, 253)',
    textAlign: 'center',
  },
  hideLink: {
    fontSize: '0.7rem',
    color: theme.palette.primary.main,
    display: 'inline-block',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

interface Props {
  children: any;
}

const InlineHelp = ({ children }: Props) => {
  const classes = useStyles();
  const [show, setShow] = useState(false);
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  return (
    <>
      {!show && (
        <div className={classes.trigger} onClick={() => setShow(true)}>
          <HelpIcon className={classes.icon} />
          <Typography className={classes.triggerLabel}>
            {t(lang, 'misc.help')}
          </Typography>
        </div>
      )}
      {show && (
        <div className={classes.content}>
          {children}
          <Typography
            className={classes.hideLink}
            onClick={() => setShow(false)}>
            {t(lang, 'misc.hide_help')}
          </Typography>
        </div>
      )}
    </>
  );
};

export default InlineHelp;
